export default {"src":"/_next/static/media/level-advanced.35b1d544.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};